import { autoBatchEnhancer } from "@reduxjs/toolkit";
import React, { useCallback, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import ApiService from "../../../network/ApiService";
import "./Team.css";
import Staff from "./Staff";

function Team() {
  const [committeeList, setCommitteeList] = useState([]);
  const { organizationId } = useSelector((state) => state.organization);
  const {
    fetchNewsUpdates,
    fetchContact,
    fetchAboutUs,
    fetchSliderImages,
    fetchStaffs,
    fetchGalleries,
  } = ApiService();

  const getStaffList = async () => {
    try {
      const response = await fetchStaffs();
      setCommitteeList(response.data.committee);
    } catch (error) {
      console.log(error.message);
    }
  };

  useEffect(() => {
    if (organizationId) {
      getStaffList();
    }
  }, [organizationId]);

  return (
    <div>
      <section id="team" className="team section-bg">
        <div className="container">
          <div className="page-heading">
            <h3 className="heading-text">सदस्य</h3>
          </div>

          {committeeList.length > 0
            ? committeeList.map((data, index) => {
                return (
                  <div className="card mb-4 board-section" key={index}>
                    <div className="card-header">
                      <h3 className="card-text">{data.name}</h3>
                    </div>
                    <div className="card-body">
                      <div className="container mb-5 board-members">
                        {data.subHeaders && data.subHeaders.length > 0 ? (
                          <div className="row">
                            {data.subHeaders.map((sub, item) => {
                              return (
                                <>
                                  {!sub.staffs ? (
                                    <div
                                      className="col-lg-3 col-md-6 d-flex align-items-stretch aos-init aos-animate"
                                      data-aos="fade-up"
                                      data-aos-delay="100"
                                      key={item}
                                    >
                                      <div className="member">
                                        <div className="member-img">
                                          <img
                                            src={
                                              sub.photoUrl
                                                ? sub.photoUrl
                                                : "assets/images/avatar-placholder.png"
                                            }
                                            className="team-img"
                                            alt=""
                                          />
                                        </div>
                                        <div className="member-info">
                                          <h4 className="staff-name">
                                            {sub.name}
                                          </h4>
                                          {sub.staffDesignation ? (
                                            <>
                                              <span>
                                                {sub.staffDesignation}
                                              </span>
                                            </>
                                          ) : null}
                                          {sub.staffContactNumber1 ? (
                                            <>
                                              <span>
                                                {sub.staffContactNumber1}
                                              </span>
                                            </>
                                          ) : null}
                                        </div>
                                      </div>
                                    </div>
                                  ) : sub.staffs && sub.staffs.length < 1 ? (
                                    <div className="col-md-6" key={item}>
                                      <div className="card-header">
                                        {sub.name}
                                      </div>
                                    </div>
                                  ) : (
                                    <div className="col-md-6" key={item}>
                                      <div className="card">
                                        <div className="card-header">
                                          {sub.name}
                                        </div>
                                        {sub.staffs && sub.staffs.length > 0 ? (
                                          <div className="card-body">
                                            <div className="container">
                                              <div className="row">
                                                {sub.staffs.map(
                                                  (staff, key) => {
                                                    return (
                                                      <div
                                                        className="col-lg-6 col-md-6 d-flex align-items-stretch aos-init aos-animate"
                                                        data-aos="fade-up"
                                                        data-aos-delay="100"
                                                        key={key}
                                                      >
                                                        <Staff staffs={staff} />
                                                      </div>
                                                    );
                                                  }
                                                )}
                                              </div>
                                            </div>
                                          </div>
                                        ) : null}
                                      </div>
                                    </div>
                                  )}
                                </>
                              );
                            })}
                          </div>
                        ) : null}
                      </div>
                    </div>
                  </div>
                );
              })
            : null}
        </div>
      </section>
    </div>
  );
}

export default Team;
